import { useEffect } from "react";
import { useNavigate } from "react-router";

import { CONFIRM_MFA, ONBOARDING } from "constants/routes";
import { useLoggedInRootPath } from "hooks/useLoggedInRootPath";
import { GuardModes } from "typings/GuardModes";
import { AppTopics, UserTopics } from "typings/Topics";

export const useLoggedInRedirect = (fromPathName?: string) => {
  const navigate = useNavigate();

  const loggedInRootPath = useLoggedInRootPath(fromPathName);

  useEffect(() => {
    const navigationRequested = PubSub.subscribe(
      AppTopics.NavigationRequested,
      (_msg, data: GuardModes) => {
        if (data) navigate(data.startsWith(`/`) ? data : `/${data}`);
      },
    );

    const userLoggedIn = PubSub.subscribe(UserTopics.LoggedIn, () => {
      navigate(loggedInRootPath, { replace: true });
    });

    const userMfaRequired = PubSub.subscribe(UserTopics.MfaRequired, () => {
      navigate(CONFIRM_MFA, { replace: true });
    });

    const userRegistered = PubSub.subscribe(UserTopics.SignedUp, () => {
      navigate(ONBOARDING, { replace: true });
    });

    return () => {
      PubSub.unsubscribe(navigationRequested);
      PubSub.unsubscribe(userLoggedIn);
      PubSub.unsubscribe(userMfaRequired);
      PubSub.unsubscribe(userRegistered);
    };
  }, [navigate]);
};
